const ADMIN_TOKEN_KEY = "seeft_admin_token";

export function getStoredAdminToken(): string | null {
  try {
    const token = localStorage.getItem(ADMIN_TOKEN_KEY)?.trim();
    return token ? token : null;
  } catch {
    return null;
  }
}

export function setStoredAdminToken(token: string): void {
  try {
    localStorage.setItem(ADMIN_TOKEN_KEY, token.trim());
  } catch {
    // Ignore storage failures in private or locked-down contexts.
  }
}

export function clearStoredAdminToken(): void {
  try {
    localStorage.removeItem(ADMIN_TOKEN_KEY);
  } catch {
    // Ignore storage failures in private or locked-down contexts.
  }
}
